import React from 'react';
import homeImage from '../assets/home4.png';

const Header = () => {
  return (
    <section
      id="header"
      className="h-[60vh] sm:h-[70vh] md:h-screen flex items-start bg-cover bg-center md:bg-top relative"
      style={{
        backgroundImage: `url(${homeImage})`,
        backgroundRepeat: 'no-repeat'
      }}
    >
      {/* Enhanced Directional Vignette Effect */}
      <div className="absolute inset-0 bg-gradient-to-br from-black/90 via-black/70 to-transparent"></div>

      {/* Header Content */}
      <div className="relative z-10 pt-44 sm:pt-52 md:pt-64 pl-4 sm:pl-8 md:pl-16 lg:pl-24 text-white max-w-xs sm:max-w-md md:max-w-lg">
        <h1
          className="text-5xl sm:text-6xl md:text-7xl leading-tight drop-shadow-lg"
          style={{
            fontFamily: "'EB Garamond', serif",
            fontWeight: 500,
            letterSpacing: '0.05em',
            color: 'rgba(247, 246, 239, 0.85)',
          }}
        >
          Sally Heath
        </h1>
        <p
          className="text-xl sm:text-2xl md:text-3xl mt-2 sm:mt-3 drop-shadow-lg leading-snug"
          style={{
            fontFamily: "'Cormorant Garamond', serif",
            fontWeight: 400,
            letterSpacing: '0.05em',
            color: 'rgba(247, 246, 239, 0.85)',
            opacity: 0.95,
          }}
        >
          Pianist
        </p>
      </div>
    </section>
  );
};

export default Header;
